// extracted by mini-css-extract-plugin
export var toast = "Toast-module__toast___noSns";
export var wrapper = "Toast-module__wrapper___fLYZz";
export var fade = "Toast-module__fade___P5_4p";